import { take, call, put } from 'redux-saga/effects';
import * as types from '../../../../../../lib/actionTypes.es6'
import * as actions from './actions';

import { getCustomerClaimsDcp } from '../../../../../../lib/requests.es6';
import { GAloggerException } from '../../../../../../lib/monitoring.es6';
import { unAuthorizedNotification } from '../../../../../../lib/access.es6';




export function* getNgsCustomerClaimsRequestWatcher() {
  for (;;) {
    const request = yield take(types.GET_NGSGROUP_CUSTOMER_CLAIMS_REQUEST);
    try {
      const response = yield call(getCustomerClaimsDcp, request.payload);
      yield put(actions.getNGSGroupCustomerClaimsSuccess(response.data));
    } catch (e) {
      let errorMessage = 'An unexpected error occurred';
      if (e.response) {
        errorMessage = e.response.data;
      }
      yield put(actions.getNGSGroupCustomerClaimsFailure(errorMessage));

      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}
